import { currentBrowserEnvironment, detectBrowserBrand } from './support';

export type LocalRecordingEvent = 'started' | 'saved' | 'failed' | 'recovered';

export function reportLocalRecordingEvent(event: LocalRecordingEvent) {
    fetch('/api/metrics/local-recording', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event, browser: detectBrowserBrand(currentBrowserEnvironment()) }),
        keepalive: true,
    }).catch((error: unknown) => {
        console.warn('Local recording metric was not sent', error);
    });
}
